import { all, takeEvery, put, fork } from "redux-saga/effects";

import axios from "./initialize";
import {
  GET_INSTANCE_TEMPLATE_LIST,
  ADD_INSTANCE_TEMPLATE,
  DELETE_INSTANCE_TEMPLATE,
  UPDATE_INSTANCE_TEMPLATE,
  GET_INSTANCE_TEMPLATE_PAGE_DRAFT_LIST,
  ADD_INSTANCE_TEMPLATE_PAGE_DRAFT,
  DELETE_INSTANCE_TEMPLATE_PAGE_DRAFT,
  UPDATE_INSTANCE_TEMPLATE_PAGE_DRAFT,
} from "redux/constants/templatePageInstance";
import {instanceTemplates,showInstanceTemplateMessage, instanceTemplatePagesDraft, showInstanceTemplatePageDraftMessage} from "redux/actions/templatePageInstance";
import trace from "auth/trace";
import { v4 as uuidv4 } from "uuid";
import { API_BASE_DEVELOPER_APP, API_BASE_URL } from "configs/AppConfig";
import { AUTH_TOKEN } from "redux/constants/Auth";
import { message, Modal } from "antd";
import { t } from "i18next";
import { CheckCircleFilled} from '@ant-design/icons';


export function* getInstanceTemplateList() {
  yield takeEvery(GET_INSTANCE_TEMPLATE_LIST, function* ({ payload }) {
    const {query,appInstanceId} = payload;
    const accountId = localStorage.getItem("accountId");
    const config = {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
        accountId: localStorage.getItem("accountId"),
        appInstanceId: appInstanceId,
        accountUserId: localStorage.getItem("accountUserId")
      },
    };
    try {
      const response = yield axios.get(
        `${API_BASE_DEVELOPER_APP}/developerApp/instance-templates?accountId=${accountId}&appInstanceId=${appInstanceId}&query=${
          query
        }&sortBy=${payload?.sorter?.field}&sortDir=${
            payload?.sorter?.order
        }&page=${payload?.pagination?.current - 1}&size=${
            payload?.pagination?.pageSize
        }`,
        config
      );
      if (response.status === 200) {
        if(query!==undefined && query!==""){
            const traceObj ={
                type: `search_get_instance_templates`,
                event: 'click',
                message: `${response?.data?.totalElements-1} results found for accountId=${accountId} and Keyword=${payload?.query}`,
                status: `instance instance templates retrieve successfully `,
                action: `Search get ${payload?.type}s`,
                referer_action_id: localStorage.getItem("referer_action_id"),
                trackId: uuidv4(),
                user_session: sessionStorage.getItem("user_session")
            };
                localStorage.setItem("referer_action_id",traceObj.trackId);
                trace({"traceObj":traceObj});
			}else{
            const traceObj ={
                type: `get_instance_templates`,
                event: 'click',
                message: `${response?.data?.totalElements-1} results found for accountId=${accountId}`,
                status: `${response?.type}s retrieve successfully `,
                action: `clicked get instance instance templates`,
                referer_action_id: localStorage.getItem("referer_action_id"),
                trackId: uuidv4(),
                user_session: sessionStorage.getItem("user_session")
            };
            localStorage.setItem("referer_action_id",traceObj.trackId);
            trace({"traceObj":traceObj});
			}		
        yield put(instanceTemplates(response.data));
      }
    } catch (error) {
            if(query!==undefined && query!==""){
            const traceObj ={
                type: `search_get_instance_templates`,
                event: 'click',
                message: `0 results found for keyword=${payload?.query} and accountId=${accountId}`,
                status: `Failed to retrieve instance instance templates`,
                action: `Search tp get instance instance templates`,
                referer_action_id: localStorage.getItem("referer_action_id"),
                trackId: uuidv4(),
                user_session: sessionStorage.getItem("user_session")
                };
                localStorage.setItem("referer_action_id",traceObj.trackId);
                trace({"traceObj":traceObj});
            }else{
                const traceObj ={
                type: `get_instance_templates`,
                event: 'click',
                message: `0 results found for accountId=${accountId}`,
                status: `Failed to retrieve instance templates`,
                action: `clicked get instance templates`,
                referer_action_id: localStorage.getItem("referer_action_id"),
                trackId: uuidv4(),
                user_session: sessionStorage.getItem("user_session")
                };
                localStorage.setItem("referer_action_id",traceObj.trackId);
                trace({"traceObj":traceObj});
            }
            console.log(error);
            // message.error(error?.response?.data?.error?error?.response?.data?.error:error?.response?.data?error?.response?.data:error?.response?error?.response:error);
            yield put(showInstanceTemplateMessage(error));
    }
  });
}

export function* addInstanceTemplate() {
    yield takeEvery(ADD_INSTANCE_TEMPLATE, function* ({ payload }) {
      try {
        const accountId = localStorage.getItem("accountId");
        const {appId,query,appInstanceId}=payload;
        const config = {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
            Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
            accountId: localStorage.getItem("accountId"),
            appInstanceId: appInstanceId,
            accountUserId: localStorage.getItem("accountUserId")
          },
        };
        const res = yield axios.post(
          `${API_BASE_DEVELOPER_APP}/developerApp/instance-templates`,
          payload,
          config
        );
        if (res.status === 201) {
          const traceObj ={
            type: `add_instance_template`,
            event: 'click',
            message: `App instance template added successfully  for name=${payload?.name}`,
            status: `App instance template added successfully `,
            action: `Clicked instance template to add`,
            referer_action_id: localStorage.getItem("referer_action_id"),
            trackId: uuidv4(),
            user_session: sessionStorage.getItem("user_session")
            }; 
            localStorage.setItem("referer_action_id",traceObj.trackId);
            trace({"traceObj":traceObj});
            const response = yield axios.get(
                `${API_BASE_DEVELOPER_APP}/developerApp/instance-templates?accountId=${accountId}&appId=${appId}&appInstanceId=${appInstanceId}&query=${
                  query
                }&sortfield=${payload?.sorter?.field}&sortorder=${
                    payload?.sorter?.order
                }&page=${payload?.pagination?.current - 1}&size=${
                    payload?.pagination?.pageSize
                }`,
                config
              );
              if (response.status === 200) {
                Modal.success({
                  title: t("impaqx.adminApp.appInstanceTemplateSuccessMessage"),
                  icon: <CheckCircleFilled />,
                  okText: t("impaqx.adminApp.close"),
                  //cancelText: 'Cancel',
                  onOk() {
                    //deleteApp(id);
                  },
                });
                yield put(instanceTemplates(response.data));
              }
            }
      } catch (error) {
        const traceObj ={
          type: `add_instance_template`,
          event: 'click',
          message: ` Failed to add instance template name=${payload?.name}`,
          status: `Failed to add instance template`,
          action: `Clicked instance template to add`,
          referer_action_id: localStorage.getItem("referer_action_id"),
          trackId: uuidv4(),
          user_session: sessionStorage.getItem("user_session")
          }; 
          localStorage.setItem("referer_action_id",traceObj.trackId);
          trace({"traceObj":traceObj});
        console.log(error);
        // message.error(error?.response?.data?.error?error?.response?.data?.error:error?.response?.data?error?.response?.data:error?.response?error?.response:error);
        yield put(showInstanceTemplateMessage(error));
      }
    });
  }
  
  export function* deleteInstanceTemplate() {
    yield takeEvery(DELETE_INSTANCE_TEMPLATE, function* ({ payload }) {
      try {
        const accountId = localStorage.getItem("accountId");
        const config = {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
            Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
            accountId: localStorage.getItem("accountId"),
            appInstanceId: payload?.appInstanceId,
            accountUserId: localStorage.getItem("accountUserId")
          },
        };
        const res = yield axios.delete(
          `${API_BASE_DEVELOPER_APP}/developerApp/instance-templates/${payload?.id}`,
          config
        );
        if (res.status === 200) {
          const traceObj ={
            type: `delete_instance_template`,
            event: 'click',
            message: `instance template deleted for id=${payload?.id}`,
            status: `instance template deleted`,
            action: `Clicked delete instance template`,
            referer_action_id: localStorage.getItem("referer_action_id"),
            trackId: uuidv4(),
            user_session: sessionStorage.getItem("user_session")
            }; 
            localStorage.setItem("referer_action_id",traceObj.trackId);
            trace({"traceObj":traceObj});
          //yield put(showAccountMessage(res));
          const response = yield axios.get(
            `${API_BASE_DEVELOPER_APP}/developerApp/instance-templates?accountId=${accountId}&appId=${payload?.appId}&appInstanceId=${payload?.appInstanceId}&query=${
              payload?.query
            }&sortfield=${payload?.sorter?.field}&sortorder=${
              payload?.sorter?.order
            }&page=${payload?.pagination?.current - 1}&size=${
              payload?.pagination?.pageSize
            }`,
            config
          );
          if (response.status === 200) {
             Modal.success({
              title: `${payload.name}  ${t("impaqx.adminApp.appInstanceTemplateDeleteMessage")}`,
              icon: <CheckCircleFilled />,
              okText: "Close",
              //cancelText: 'Cancel',
              onOk() {
                //deleteApp(id);
              },
            });
            yield put(instanceTemplates(response.data));
          }
        }
      } catch (error) {
        const traceObj ={
          type: `delete_instance_template`,
          event: 'click',
          message: `Failed to delete instance template id=${payload.id}`,
          status: `Failed to delete instance template`,
          action: `Clicked to delete instance template`,
          referer_action_id: localStorage.getItem("referer_action_id"),
          trackId: uuidv4(),
          user_session: sessionStorage.getItem("user_session")
          }; 
          localStorage.setItem("referer_action_id",traceObj.trackId);
          trace({"traceObj":traceObj});
        console.log(error);
        //message.error(error?.response?.data?.error?error?.response?.data?.error:error?.response?.data?error?.response?.data:error?.response?error?.response:error);
        yield put(showInstanceTemplateMessage(error));
      }
    });
  }

  export function* updateInstanceTemplate() {
    yield takeEvery(UPDATE_INSTANCE_TEMPLATE, function* ({ payload }) {
      const appInstanceTemplate=payload;
      const config = {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
          Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
          accountId: localStorage.getItem("accountId"),
          appInstanceId: appInstanceTemplate?.appInstanceId,
          accountUserId: localStorage.getItem("accountUserId")
        },
      };
      try {
        const res = yield axios.put(
          `${API_BASE_DEVELOPER_APP}/developerApp/instance-templates/${appInstanceTemplate?.id}`,
          appInstanceTemplate,
          config
        );
        if (res.status === 200) {
          const traceObj ={
              type: `update_instance_template`,
              event: 'click',
              message: `instance template updated for id=${payload.id}`,
              status: `instance template updated`,
              action: `Clicked to update instance template`,
              referer_action_id: localStorage.getItem("referer_action_id"),
              trackId: uuidv4(),
              user_session: sessionStorage.getItem("user_session")
              }; 
              localStorage.setItem("referer_action_id",traceObj.trackId);
              trace({"traceObj":traceObj});
          const response = yield axios.get(
            `${API_BASE_DEVELOPER_APP}/developerApp/instance-templates?accountId=${appInstanceTemplate?.accountId}&appId=${appInstanceTemplate?.appId}&appInstanceId=${appInstanceTemplate?.appInstanceId}&query=${
              payload?.query
            }&sortfield=${payload?.sorter?.field}&sortorder=${
              payload?.sorter?.order
            }&page=${payload?.pagination?.current - 1}&size=${
              payload?.pagination?.pageSize
            }`,
            config
          );
          if (response.status === 200) {
            Modal.success({
                title: t("impaqx.adminApp.instanceTemplateUpdateMessage"),
                icon: <CheckCircleFilled />,
                okText:t("impaqx.adminApp.close"),
                //cancelText: 'Cancel',
                onOk() {
                  //deleteApp(id);
                },
              });
            yield put(instanceTemplates(response.data));
          }
        //   yield put(showInstanceTemplateMessage(res));
        }
      } catch (error) {
        const traceObj ={
          type: `update_instance_template`,
          event: 'click',
          message: `Failed to update instance template for id=${payload.id}`,
          status: `Failed to update instance template`,
          action: `Clicked update instance template`,
          referer_action_id: localStorage.getItem("referer_action_id"),
          trackId: uuidv4(),
          user_session: sessionStorage.getItem("user_session")
          }; 
          localStorage.setItem("referer_action_id",traceObj.trackId);
          trace({"traceObj":traceObj});
        console.log(error);
        //message.error(error?.response?.data?.error?error?.response?.data?.error:error?.response?.data?error?.response?.data:error?.response?error?.response:error);
        yield put(showInstanceTemplateMessage(error));
      }
    });
  }

  export function* getInstanceTemplatePageDraftList() {
    yield takeEvery(GET_INSTANCE_TEMPLATE_PAGE_DRAFT_LIST, function* ({ payload }) {
      const {query,appInstanceId,instanceTemplateId,selectedTab} = payload;
      const accountId = localStorage.getItem("accountId");
      const config = {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
          Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
          accountId: localStorage.getItem("accountId"),
          appInstanceId: appInstanceId,
          accountUserId: localStorage.getItem("accountUserId")
        },
      };
      let url = `${API_BASE_DEVELOPER_APP}/developerApp/instance-template-pages-draft?accountId=${accountId}&instanceTemplateId=${instanceTemplateId}&query=${query
      }&sortfield=${payload?.sorter?.field}&sortorder=${payload?.sorter?.order}&page=${payload?.pagination?.current - 1}&size=${payload?.pagination?.pageSize}`;
      if(selectedTab==="published"){
        url = `${API_BASE_DEVELOPER_APP}/developerApp/instance-template-pages?accountId=${accountId}&instanceTemplateId=${instanceTemplateId}&query=${query
        }&sortfield=${payload?.sorter?.field}&sortorder=${payload?.sorter?.order}&page=${payload?.pagination?.current - 1}&size=${payload?.pagination?.pageSize}`;
      }
      try {
        const response = yield axios.get(
          url,
          config
        );
        if (response.status === 200) {
          if(query!==undefined && query!==""){
              const traceObj ={
                  type: `search_get_instance_templates_pages_draft`,
                  event: 'click',
                  message: `${response?.data?.totalElements-1} results found for accountId=${accountId} and instanceTemplateId=${instanceTemplateId} and Keyword=${payload?.query}`,
                  status: `instance templates pages draft retrieve successfully `,
                  action: `Search get instance templates pages draft`,
                  referer_action_id: localStorage.getItem("referer_action_id"),
                  trackId: uuidv4(),
                  user_session: sessionStorage.getItem("user_session")
              };
                  localStorage.setItem("referer_action_id",traceObj.trackId);
                  trace({"traceObj":traceObj});
              }else{
              const traceObj ={
                  type: `get_instance_templates_pages_draft`,
                  event: 'click',
                  message: `${response?.data?.totalElements-1} results found for accountId=${accountId} and instanceTemplateId=${instanceTemplateId}`,
                  status: `instance template pages draft retrieve successfully `,
                  action: `clicked get instance template pages draft`,
                  referer_action_id: localStorage.getItem("referer_action_id"),
                  trackId: uuidv4(),
                  user_session: sessionStorage.getItem("user_session")
              };
              localStorage.setItem("referer_action_id",traceObj.trackId);
              trace({"traceObj":traceObj});
              }		
          yield put(instanceTemplatePagesDraft(response.data));
        }
      } catch (error) {
              if(query!==undefined && query!==""){
              const traceObj ={
                  type: `search_get_instance_template_pages_draft`,
                  event: 'click',
                  message: `0 results found for keyword=${payload?.query} and accountId=${accountId} and instanceTemplateId=${instanceTemplateId}`,
                  status: `Failed to retrieve instance template pages draft`,
                  action: `Search tp get instance template pages draft`,
                  referer_action_id: localStorage.getItem("referer_action_id"),
                  trackId: uuidv4(),
                  user_session: sessionStorage.getItem("user_session")
                  };
                  localStorage.setItem("referer_action_id",traceObj.trackId);
                  trace({"traceObj":traceObj});
              }else{
                  const traceObj ={
                  type: `get_instance_template_pages_draft`,
                  event: 'click',
                  message: `0 results found for accountId=${accountId} and instanceTemplateId=${instanceTemplateId}`,
                  status: `Failed to retrieve instance template pages draft`,
                  action: `clicked get instance template pages draft`,
                  referer_action_id: localStorage.getItem("referer_action_id"),
                  trackId: uuidv4(),
                  user_session: sessionStorage.getItem("user_session")
                  };
                  localStorage.setItem("referer_action_id",traceObj.trackId);
                  trace({"traceObj":traceObj});
              }
              console.log(error);
              //message.error(error?.response?.data?.error?error?.response?.data?.error:error?.response?.data?error?.response?.data:error?.response?error?.response:error);
              yield put(showInstanceTemplatePageDraftMessage(error?.response));
      }
    });
  }
  
  export function* addInstanceTemplatePageDraft() {
      yield takeEvery(ADD_INSTANCE_TEMPLATE_PAGE_DRAFT, function* ({ payload }) {
        const {values,publish}=payload;
        try {
          const accountId = localStorage.getItem("accountId");
          const config = {
            headers: {
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": "*",
              "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
              Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
              accountId: localStorage.getItem("accountId"),
              appInstanceId: values?.appInstanceId,
              accountUserId: localStorage.getItem("accountUserId")
            },
          };
          const response = yield axios.post(
            `${API_BASE_DEVELOPER_APP}/developerApp/instance-template-pages-draft`,
            values,
            config
          );
          if (response.status === 201) {
            if(publish==="publish"){
              const draftId = response?.data?.id;
            const publishResponse = yield axios.get(
              `${API_BASE_DEVELOPER_APP}/developerApp/instance-template-pages/${draftId}/publish`,
              config
            );
            if (publishResponse.status === 201) {
              Modal.success({
                title: t("impaqx.adminApp.appInstanceTemplatePagePublishSuccessMessage"),
                icon: <CheckCircleFilled />,
                okText: t("impaqx.adminApp.close"),
                //cancelText: 'Cancel',
                onOk() {
                  //deleteApp(id);
                },
              });
            }
            }
            const traceObj ={
              type: `add_instance_template_page_draft`,
              event: 'click',
              message: `instance template page draft added successfully  for name=${values?.pageName}`,
              status: `instance template page draft added successfully `,
              action: `Clicked instance template page draft to add`,
              referer_action_id: localStorage.getItem("referer_action_id"),
              trackId: uuidv4(),
              user_session: sessionStorage.getItem("user_session")
              }; 
              localStorage.setItem("referer_action_id",traceObj.trackId);
              trace({"traceObj":traceObj});
              var draft = "instance-template-pages-draft";
                if(publish==="publish")
                draft="instance-template-pages"
                const res = yield axios.get(
                  `${API_BASE_DEVELOPER_APP}/developerApp/${draft}?accountId=${accountId}&instanceTemplateId=${values?.instanceTemplateId}&appId=${values?.appId}&query=${
                    values?.query
                  }&sortfield=${payload?.sorter?.field}&sortorder=${
                    values?.sorter?.order
                  }&page=${values?.pagination?.current - 1}&size=${
                    values?.pagination?.pageSize
                  }`,
                  config
                );
                if (res.status === 200) {
                  if(publish!=="publish")
                  Modal.success({
                    title: t("impaqx.adminApp.instanceTemplatePageDraftSuccessMessage"),
                    icon: <CheckCircleFilled />,
                    okText: t("impaqx.adminApp.close"),
                    //cancelText: 'Cancel',
                    onOk() {
                      //deleteApp(id);
                    },
                  });
                  yield put(instanceTemplatePagesDraft(res.data));
                }
              }
        } catch (error) {
          const traceObj ={
            type: `add_instance_template_page_draft`,
            event: 'click',
            message: ` Failed to add instance template page draft name=${values?.pageName}`,
            status: `Failed to add instance template page draft`,
            action: `Clicked instance template page draft to add`,
            referer_action_id: localStorage.getItem("referer_action_id"),
            trackId: uuidv4(),
            user_session: sessionStorage.getItem("user_session")
            }; 
            localStorage.setItem("referer_action_id",traceObj.trackId);
            trace({"traceObj":traceObj});
          console.log(error);
          //message.error(error?.response?.data?.error?error?.response?.data?.error:error?.response?.data?error?.response?.data:error?.response?error?.response:error);
          yield put(showInstanceTemplatePageDraftMessage(error?.response));
        }
      });
    }
    
    export function* deleteInstanceTemplatePageDraft() {
      yield takeEvery(DELETE_INSTANCE_TEMPLATE_PAGE_DRAFT, function* ({ payload }) {
        const {instanceTemplatePageDraft,selectedTab,appInstanceId}=payload;
        try {
          const accountId = localStorage.getItem("accountId");
          const config = {
            headers: {
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": "*",
              "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
              Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
              accountId: localStorage.getItem("accountId"),
              appInstanceId: appInstanceId,
              accountUserId: localStorage.getItem("accountUserId")
            },
          };
          var url = `${API_BASE_DEVELOPER_APP}/developerApp/instance-template-pages-draft/${instanceTemplatePageDraft?.id}`;
          if(selectedTab==="published"){
             url = `${API_BASE_DEVELOPER_APP}/developerApp/instance-template-pages/${instanceTemplatePageDraft?.id}`
          }
          const res = yield axios.delete(
            url,
            config
          );
          if (res.status === 200) {
            const traceObj ={
              type: `delete_instance_template_page_draft`,
              event: 'click',
              message: `instance template page draft deleted for id=${instanceTemplatePageDraft?.id}`,
              status: `instance template page draft deleted`,
              action: `Clicked delete instance template page draft`,
              referer_action_id: localStorage.getItem("referer_action_id"),
              trackId: uuidv4(),
              user_session: sessionStorage.getItem("user_session")
              }; 
              localStorage.setItem("referer_action_id",traceObj.trackId);
              trace({"traceObj":traceObj});
            //yield put(showAccountMessage(res));
            const res = yield axios.get(
                `${API_BASE_DEVELOPER_APP}/developerApp/instance-template-pages-draft?accountId=${accountId}&instanceTemplateId=${instanceTemplatePageDraft?.instanceTemplateId}&appId=${instanceTemplatePageDraft?.appId}&query=${
                  payload?.query
                }&sortfield=${payload?.sorter?.field}&sortorder=${
                  payload?.sorter?.order
                }&page=${payload?.pagination?.current - 1}&size=${
                  payload?.pagination?.pageSize
                }`,
                config
              );
              if (res.status === 200) {
                var title = t("impaqx.adminApp.appInstanceTemplatePageDraftDeleteMessage");
                if(selectedTab==="published")
                  title = t("impaqx.adminApp.appInstanceTemplatePagedDeleteMessage");
                //message.success(title);
                Modal.success({
                  title: title,
                  icon: <CheckCircleFilled />,
                  okText: t("impaqx.adminApp.close"),
                  //cancelText: 'Cancel',
                  onOk() {
                    //deleteApp(id);
                  },
                });
                yield put(instanceTemplatePagesDraft(res.data));
              }
          }
        } catch (error) {
          const traceObj ={
            type: `delete_instance_template_page_draft`,
            event: 'click',
            message: `Failed to delete instance template page draft id=${instanceTemplatePageDraft.id}`,
            status: `Failed to delete instance template page draft`,
            action: `Clicked to delete instance template page draft`,
            referer_action_id: localStorage.getItem("referer_action_id"),
            trackId: uuidv4(),
            user_session: sessionStorage.getItem("user_session")
            }; 
            localStorage.setItem("referer_action_id",traceObj.trackId);
            trace({"traceObj":traceObj});
          console.log(error);
          //message.error(error);
          //message.error(error?.response?.data?.error?error?.response?.data?.error:error?.response?.data?error?.response?.data:error?.response?error?.response:error);
          yield put(showInstanceTemplatePageDraftMessage(error?.response));
        }
      });
    }
  
    export function* updateInstanceTemplatePageDraft() {
      yield takeEvery(UPDATE_INSTANCE_TEMPLATE_PAGE_DRAFT, function* ({ payload }) {
        const {values,publish,status}=payload;
        const instanceTemplatePageDraft=values;
        const accountId = localStorage.getItem("accountId");
        const config = {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
            Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
            accountId: localStorage.getItem("accountId"),
            appInstanceId: localStorage.getItem("appInstanceId"),
            accountUserId: localStorage.getItem("accountUserId")
          },
        };
        try {
          const draftResponse = yield axios.put(
            `${API_BASE_DEVELOPER_APP}/developerApp/instance-template-pages-draft/${instanceTemplatePageDraft?.id}`,
            instanceTemplatePageDraft,
            config
          );
          if (draftResponse.status === 200) {
            const draftId = draftResponse?.data?.id;
            if(publish==="publish"){
            const publishResponse = yield axios.get(
              `${API_BASE_DEVELOPER_APP}/developerApp/instance-template-pages/${draftId}/publish`,
              config
            );
            if (publishResponse.status === 201) {
              var message =  t("impaqx.adminApp.appInstanceTemplatePagePublishSuccessMessage");
              if(status)
               message = t("impaqx.adminApp.appTemplatePageStatusUpdateMessage")
              Modal.success({
                title:message,
                icon: <CheckCircleFilled />,
                okText: t("impaqx.adminApp.close"),
                //cancelText: 'Cancel',
                onOk() {
                  //deleteApp(id);
                },
              });
            }
            }
            const traceObj ={
                type: `update_instance_template_pages_draft`,
                event: 'click',
                message: `instance template pages draft updated for id=${payload.id}`,
                status: `instance template page draft updated`,
                action: `Clicked to update instance template page draft`,
                referer_action_id: localStorage.getItem("referer_action_id"),
                trackId: uuidv4(),
                user_session: sessionStorage.getItem("user_session")
                }; 
                localStorage.setItem("referer_action_id",traceObj.trackId);
                trace({"traceObj":traceObj});
                var draft = "instance-template-pages-draft";
                if(publish==="publish")
                draft="instance-template-pages"
                const res = yield axios.get(
                    `${API_BASE_DEVELOPER_APP}/developerApp/${draft}?accountId=${accountId}&instanceTemplateId=${instanceTemplatePageDraft?.instanceTemplateId}&appId=${instanceTemplatePageDraft?.appId}&query=${
                      payload?.query
                    }&sortfield=${payload?.sorter?.field}&sortorder=${
                      payload?.sorter?.order
                    }&page=${payload?.pagination?.current - 1}&size=${
                      payload?.pagination?.pageSize
                    }`,
                    config
                  );
                  if (res.status === 200) {
                    var message = t("impaqx.adminApp.instanceTemplatePageDraftSuccessMessage");
                    if(status)
                      message = t("impaqx.adminApp.appTemplatePageStatusUpdateMessage")
                    if(publish!=="publish")
                    Modal.success({
                      title: message,
                      icon: <CheckCircleFilled />,
                      okText: t("impaqx.adminApp.close"),
                      //cancelText: 'Cancel',
                      onOk() {
                        //deleteApp(id);
                      },
                    });
                    yield put(instanceTemplatePagesDraft(res.data));
                  }
          }
        } catch (error) {
          const traceObj ={
            type: `update_instance_template_page_draft`,
            event: 'click',
            message: `Failed to update instance template page draft for id=${payload.id}`,
            status: `Failed to update instance template page draft`,
            action: `Clicked update instance template page draft`,
            referer_action_id: localStorage.getItem("referer_action_id"),
            trackId: uuidv4(),
            user_session: sessionStorage.getItem("user_session")
            }; 
            localStorage.setItem("referer_action_id",traceObj.trackId);
            trace({"traceObj":traceObj});
          console.log(error);
          //message.error(error?.response?.data?.error?error?.response?.data?.error:error?.response?.data?error?.response?.data?.message:error?.response?.message?error?.response?.message:error?.response?.error?
            // error?.response?.error:error?.response?error?.response:error);
          yield put(showInstanceTemplatePageDraftMessage(error?.response));
        }
      });
    }

export default function* rootSaga() {
    yield all([
      fork(getInstanceTemplateList),
      fork(addInstanceTemplate),
      fork(deleteInstanceTemplate),
      fork(updateInstanceTemplate),
      fork(getInstanceTemplatePageDraftList),
      fork(addInstanceTemplatePageDraft),
      fork(deleteInstanceTemplatePageDraft),
      fork(updateInstanceTemplatePageDraft)
    ]);
  }
  